import { gql } from "@apollo/client";

export const DELETE_MESSAGE = gql`
    mutation DeleteMessage($id: ID!) {
        deleteMessage(id: $id) {
            id
        }
    }
`;